import BuildingImage from "../../Assets/building.svg";

const BuildingIcon = ({ building, isSelected, onSelectBuilding }: any) => {
  return (
    <>
      <div className={"d-flex align-items-center"} style={{ verticalAlign: "middle" }} onClick={() => onSelectBuilding(building)}>
        <img src={BuildingImage} alt={building.name} height="60px" width="60px" />
        <span>{" " + building.name}</span>
      </div>
    </>
  );
};

export default BuildingIcon;
